import { TicketAnalyticsView } from '../../components/analytics/TicketAnalyticsView'

function AdminAnalytics() {
  return <TicketAnalyticsView />
}

export default AdminAnalytics
